// Containers
import SettingsContainer from 'delivery/modules/Settings/containers/SettingsContainer'

// Routes
import SettingsMenuRoutes from './routes/SettingsMenuRoutes'


const SettingsRoutes = [
  {
    path: '/:username/settings',
    component: SettingsContainer,
    routes: [
      ...SettingsMenuRoutes
    ]
  }
]

export default SettingsRoutes
